import { Loader } from "./Loader";
import { Input } from "./Input";
import { List } from "./List";

export class VertexWeightContainer {

    public count: number;
    public inputs: Input[];
    public vertexCount: Int32Array;
    public vertexIndices: Int32Array;
    public sampleOffsets: number[];

    public loadBlob(dataView: DataView, loader: Loader) {
        let offset = 0;

        this.count = dataView.getInt32(offset, true);
        offset += 4;

        let listReference = dataView.getInt32(offset, true);
        offset += 4;

        this.inputs = loader.getBlob<List>(listReference).getItems<Input>();

        let vertexCountResult = loader.util.readIntList(dataView, offset);
        this.vertexCount = vertexCountResult.ints;
        offset = vertexCountResult.offset;

        let vertexIndicesResult = loader.util.readIntList(dataView, offset);
        this.vertexIndices = vertexIndicesResult.ints;
        offset = vertexIndicesResult.offset;
    }

    public getInput(semantic: string): Input {
        let input = this.inputs.find(input => input.semantic == semantic)

        return input ? input : null;
    }

    public preComputeSampleOffset() {
        let offsets = new Array<number>();
        let offset = 0;
        for (let i = 0; i < this.count; i++) {
            let vcount = this.vertexCount[i]; // number of joints affecting a vertex
            offsets.push(offset);
            for (let vc = 0; vc < vcount; vc++) {
                offset += 2;
            }
        }

        this.sampleOffsets = offsets;
    }
}
